import { useEffect, useRef, useState } from 'react'

const useIntersectionObserver = () => {
  const [isIntersecting, setIsIntersecting] = useState(false)
  const refNode = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!refNode) {
      return
    }

    const callback = (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
      setIsIntersecting(entries[0].isIntersecting)
    }

    const observer = new IntersectionObserver(callback, {
      root: null,
      threshold: 0,
    })

    if (refNode.current != null) {
      observer.observe(refNode.current)
    }

    return () => {
      observer.disconnect()
    }
  }, [])

  return {
    refNode,
    isIntersecting,
  }
}

export default useIntersectionObserver
